import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, retry, throwError, timer } from 'rxjs';

const MAX_NUMBER_OF_RETRY = 3;
const RETRY_DELAY = 500;

@Injectable()
export class PodcastApiRetryInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    handler: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return handler.handle(req).pipe(
      retry({
        count: MAX_NUMBER_OF_RETRY,
        delay: (
          error: HttpErrorResponse,
          retryAttempt: number,
        ): Observable<number> => {
          if (
            MAX_NUMBER_OF_RETRY > retryAttempt &&
            (error.status === 0 || error.status >= 500)
          ) {
            console.warn(
              `Retry ${req.method} ${req.url}. ${retryAttempt} attepmt`,
            );
            return timer(retryAttempt * RETRY_DELAY);
          }

          return throwError(() => error);
        },
      }),
    );
  }
}
